import { z } from "zod";

export const activeCaseFilterIds = z.object({
    idUUID: z.string(),
    clientName: z.string(),
});
